<div
  style="page-break-inside: avoid;"
  class="mt-4"
  *ngIf="incomeFormVoluntaryDisclosureData.length > 0"
  [ngClass]="{
    'container': true,
    'return-view-background-print': printActive,
    'return-view-background': !printActive
  }"
>
  <div class="row mb-4">
    <div class="col-12 text-center">
      <strong>PARTICULARS OF VOLUNTARY DISCLOSURE OF INCOME</strong>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6">
      <strong>Taxpayer Name:</strong> {{ returnData?.profileData?.assesName }}
    </div>
    <div class="col-sm-6 text-right">
      <strong>Assessment Year:</strong> {{ returnData?.submissionInfo?.assessmentYear }}
    </div>
  </div>

  <div class="row mt-3 mb-5">
    <div class="col-sm-12">
      <strong>TIN</strong>
      <span class="ml-3" style="white-space: nowrap;">
        <input
          value="{{ tinChar }}"
          *ngFor="let tinChar of ((returnData?.profileData?.tin || '') + '').split('')"
          class="input-default"
          disabled
        />
      </span>
    </div>
  </div>

  <div style="page-break-inside: avoid;" class="row mb-5">
    <div class="col-12">
      <table class="table table-bordered income-voluntary-disclosure-table">
        <thead>
          <tr class="text-center">
            <th></th>
            <th *ngFor="let col of tableColumns">{{ col.title }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of incomeFormVoluntaryDisclosureData; let i = index">
            <td class="text-center">{{ i + 1 }}</td>
            <td
              *ngFor="let col of tableColumns"
              [ngClass]="{ 'text-right pr-3': col.isAmount }"
            >
              <ng-container *ngIf="col.isAmount">
                {{ getCellValue(item, col) | currencySeparatorBD }}
              </ng-container>
              <ng-container *ngIf="!col.isAmount">
                {{ getCellValue(item, col) }}
              </ng-container>
            </td>
          </tr>
          <tr class="font-weight-bold">
            <td></td>
            <td></td>
            <td></td>
            <td class="text-center">Total Net Income</td>
            <td class="text-right pr-3">{{ getTotalNetIncome() | currencySeparatorBD }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
